export default theme => ({
 navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    padding: '0 20px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    transform: 'translate3d(0,0,0)',
    backfaceVisibility: 'hidden',
    zIndex: 999,
    transition: 'all 300ms ease-in-out',
    background: 'white !important',
    height: '140px',
  },
  navbarColor: {
    background: 'white',
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    padding: '8px 0',
  },
  logoImage: {
    objectFit: 'contain',
    height: '100px',
    width: 'auto',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.03)',
    },
    [theme.breakpoints.down('xs')]: {
      height: '48px',
    },
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    margin: '0 auto',
  },
  navLink: {
    position: 'relative',
    color: '#333',
    padding: '8px 14px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'none',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    letterSpacing: '0.3px',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '4px',
      left: '14px',
      width: '0%',
      height: '2px',
      backgroundColor: '#cc0000',
      transition: 'width 0.3s ease',
      borderRadius: '2px',
    },
    '&:hover': {
      color: '#cc0000',
    },
    '&:hover:after': {
      width: 'calc(100% - 28px)',
    },
  },
  navAccount: {
    marginLeft: '12px',
    display: 'flex',
    alignItems: 'center',
  },
  bookNowBtn: {
    position: 'relative',
    background: 'linear-gradient(135deg, #cc0000, #ff3333)',
    color: 'white',
    border: 'none',
    borderRadius: '25px',
    padding: '10px 24px',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    letterSpacing: '0.5px',
    boxShadow: '0 4px 15px rgba(204,0,0,0.3)',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(204,0,0,0.4)',
      background: 'linear-gradient(135deg, #aa0000, #cc0000)',
    },
    '&:active': {
      transform: 'translateY(0px)',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '-50%',
      left: '-60%',
      width: '40%',
      height: '200%',
      background: 'rgba(255,255,255,0.2)',
      transform: 'skewX(-20deg)',
      transition: 'left 0.5s ease',
    },
    '&:hover:before': {
      left: '120%',
    },
  },
  search: {
    position: 'relative',
    borderRadius: '25px',
    backgroundColor: '#f5f5f5',
    border: '1.5px solid #e8e8e8',
    transition: 'all 0.3s ease',
    marginLeft: '8px',
    '&:hover': {
      border: '1.5px solid #cc0000',
      backgroundColor: '#fff',
      boxShadow: '0 0 0 3px rgba(204,0,0,0.08)',
    },
    '&:focus-within': {
      border: '1.5px solid #cc0000',
      backgroundColor: '#fff',
      boxShadow: '0 0 0 3px rgba(204,0,0,0.1)',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  searchIcon: {
    padding: '0 12px',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
  },
  inputRoot: {
    color: '#333',
    height: '40px',
  },
  inputInput: {
    padding: '8px 16px 8px 0',
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: 'width 0.3s ease',
    width: '140px',
    fontSize: '14px',
    '&:focus': {
      width: '200px',
    },
    '&::placeholder': {
        color: '#000',
      opacity: 1,
    },
  },
  navMobile: {
    marginLeft: 'auto',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  navIcon: {
    display: 'none',
    height: '22px',
    width: '30px',
    position: 'relative',
    zIndex: 2,
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&:hover $navIconLine__left, &:hover $navIconLine__right': {
      width: '30px',
    },
  },
  navIconLine: {
    height: '2.5px',
    width: '30px',
    display: 'block',
    backgroundColor: '#333',
    borderRadius: '2px',
    transition: 'all 0.2s ease',
  },
  navIconLine__left: {
    width: '20px',
    transition: 'all 200ms linear',
  },
  navIconLine__right: {
    width: '20px',
    transition: 'all 200ms linear',
  },
  nav: {
    display: 'flex',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
    paddingLeft: 0,
    marginBottom: 0,
    '&:before, &:after': {
      content: '""',
      position: 'fixed',
      width: '100vw',
      height: '100vh',
      background: 'rgba(255,255,255,0.1)',
      zIndex: '-1',
      transition: 'transform cubic-bezier(0.77, 0, 0.175, 1) 0.8s',
      transform: 'translateX(0%) translateY(-100%)',
    },
    '&:before': {
      background: '#111',
      transitionDelay: '0s',
    },
    '&:after': {
      transitionDelay: '.1s',
    },
  },
  navActive: {
    visibility: 'visible',
    zIndex: 9,
    '&:before': {
      transitionDelay: '0s',
      transform: 'translateX(0%) translateY(0%)',
    },
    '&:after': {
      transitionDelay: '.1s',
      transform: 'translateX(0%) translateY(0%)',
    },
    '& $navContent': {
      visibility: 'visible',
    },
    '& $navContent $currentPageShadow': {
      transitionDelay: '.5s',
      opacity: 0.03,
      marginTop: '0',
    },
    '& $navContent $innerNavListItem': {
      transitionDelay: '.5s',
      opacity: 1,
      transform: 'translateX(0%)',
      transition: 'opacity .3s ease, transform .3s ease',
    },
  },
  navContent: {
    position: 'fixed',
    visibility: 'hidden',
    top: '50%',
    transform: 'translate(0%, -50%)',
    width: '100%',
  },
  currentPageShadow: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontFamily: 'sans-serif',
    fontSize: '10rem',
    fontWeight: 800,
    marginTop: '25px',
    color: '#fff',
    opacity: 0,
    transition: 'all 300ms linear',
  },
  innerNav: {
    position: 'relative',
    padding: 0,
    margin: 0,
    zIndex: 2,
  },
  innerNavListItem: {
    opacity: 0,
    position: 'relative',
    display: 'block',
    textAlign: 'center',
    fontSize: '4rem',
    lineHeight: '1.2',
    letterSpacing: '3px',
    transform: 'translate(0%, 100%)',
    transition: 'opacity .2s ease, transform .3s ease',
    padding: '8px 0',
  },
  innerNavLink: {
    position: 'relative',
    color: 'white',
    padding: '0 .5rem',
    margin: '0 1rem',
    fontSize: '2.2rem',
    fontWeight: 700,
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: '#ff4444',
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '-4px',
      left: 0,
      width: '0%',
      height: '3px',
      backgroundColor: '#cc0000',
      transition: 'width 0.3s ease',
      borderRadius: '2px',
    },
    '&:hover:after': {
      width: '100%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    navIcon: { display: 'flex' },
    navLinks: { display: 'none' },
    navAccount: { display: 'none' },
    search: { display: 'none' },
  },
});